import React, { useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  accountLogAPI,
  getBetsFromAccountLogs,
  getCollectionReportAPI,
} from "../service/AuthService";
import moment from "moment";
import Loader from "./components/Loader";

export default function Ledger({ isCashLedger, isCollectionReport }) {
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const location = useLocation();

  const [isLenaDena, setIsLenaDena] = React.useState(
    location.state?.isLenaDena
  );
  const selectedUser = ''
  const [payload, setPayload] = React.useState({
    endDate: moment().format("YYYY-MM-DD HH:mm:ss"),
    startDate: moment()
      .subtract(7, "d")
      .format("YYYY-MM-DD HH:mm:ss"),
    pageSize: 100,
    search: "",
    userName: location.state?.client?.username,
  });
  const [ledgerPayload, setLedgerPayload] = React.useState({
    pageSize: 50,
    pageNumber: 0,
  });
  const [loading, setLoading] = React.useState(false);
  const [collectionReportMapping, setCollectionReportMapping] = React.useState({
    lenaHai: [],
    denaHai: [],
  });
  const userName = useParams()?.userName;
  const ledgerQuery = useQuery(
    "ledger",
    () => accountLogAPI(ledgerPayload, location.state?.isOld),
    {
      enabled: !isCollectionReport,
    }
  );


  const userType = params?.userType;
  const userTypeGet = useMemo(() => {
    if (userType?.toUpperCase() === "ADMIN") return "ADMIN";
    if (userType?.toUpperCase() === "SUBADMIN") return "SUB_ADMIN";
    if (userType?.toUpperCase() === "MASTER") return "MASTER";
    if (userType?.toUpperCase() === "SUPER") return "SUPER_AGENT";
    if (userType?.toUpperCase() === "AGENT") return "AGENT";
    if (userType?.toUpperCase() === "CLIENT") return "CLIENT";
    return "";
  }, [userType]);

  const getCollectionReport = async () => {
    const { response, code } = await getCollectionReportAPI(
      payload.startDate,
      payload.endDate,
      location.state?.isLenaDena ? "" : userTypeGet ||
        location.state?.isLenaDena ? userTypeGet : "",
      userName,
    );
    if (code === 200) {
      let data = response?.collectionReport;
      let lenaHai;
      let denaHai;
      if (selectedUser) {
        lenaHai = data?.filter(
          (item) => item?.balance > 0 && item?.userId === selectedUser?.value
        );
        denaHai = data?.filter(
          (item) => item?.balance < 0 && item?.userId === selectedUser?.value
        );
      } else {
        lenaHai = data?.filter((item) => item?.balance > 0);
        denaHai = data?.filter((item) => item?.balance < 0);
      }

      setCollectionReportMapping({
        lenaHai,
        denaHai,
      });
      const allClients = data.map((item) => ({
        value: item?.userId,
        label: item?.userName,
      }));
      // setAllClients(allClients);
    }
  };
  useEffect(() => {
    if (isCollectionReport) {
      getCollectionReport();
    }
  }, [params?.userType, userName, isCollectionReport]);

  const navigateToCt = (user) => {
    navigate(`/ct/${userType}`, {
      state: {
        ...user,
      },
    });
  };

  const isMobile = window.innerWidth < 768;

  return (
    <div
      className="content-wrapper">

      {/* Content Header (Page header) */}
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Ledger</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">My Ledger</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      {loading ?
        <Loader isLoading={loading} />
        :
        <section className="content">
          {isCollectionReport ? (
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  {/* /.card */}
                  <div className="card">
                    <form action="#" method="post" id="demoForm">
                      <div className="card-header" />
                      {/* /.card-header */}
                      <div className="card-body">
                        <div className="form-row">
                          <div className="col-md-6">
                            <table
                              id="example1"
                              className="table table-striped  table-hover table-bordered"
                            >
                              <thead>
                                <tr>
                                  <th colSpan={5}>
                                    PAYMENT RECEIVING FROM (LENA HE)
                                  </th>
                                </tr>
                                <tr>
                                  <th>User Name</th>
                                  <th>Open. Bal.</th>
                                  <th>Curr. Bal.</th>
                                  <th>Balance</th>
                                  {/* <th>Action</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {collectionReportMapping.lenaHai.map((item) => (
                                  <tr>
                                    <td>
                                      {item.userName}
                                    </td>
                                    <td className={`${item?.openingBalance > 0 ? 'plus_value' : 'mainus_value'}`}>{item?.openingBalance?.toFixed(2)}</td>
                                    <td className={`${item?.currentBalance > 0 ? 'plus_value' : 'mainus_value'}`}>{item?.currentBalance?.toFixed(2)}</td>
                                    <td className="plus_value">{item.balance.toFixed(2)}</td>
                                    {/* <td className="d-flex gap-2" style={{ gap: '5px' }}>
                                      <>
                                        <div className="btn-primary px-2 py-1" style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (item?.userType?.toUpperCase() !== "CLIENT") {
                                              navigate(
                                                `/ledger/${item?.userType}/children/${item?.userName?.split(" ")[0]}`
                                              );
                                            }
                                          }}
                                        >
                                          Downline
                                        </div>
                                        <div className="btn-primary px-3 py-1 d-flex gap-2 align-items-center" style={{ cursor: "pointer" }}
                                          onClick={() => navigateToCt(item)}>
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth={0}
                                            viewBox="0 0 24 24"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fill="none"
                                              strokeWidth={2}
                                              d="M2,7 L20,7 M16,2 L21,7 L16,12 M22,17 L4,17 M8,12 L3,17 L8,22"
                                            />
                                          </svg>
                                        </div>
                                      </>
                                    </td> */}
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td>Total</td>
                                  <td className="plus_value" rowSpan={2}>
                                    {collectionReportMapping.lenaHai.reduce(
                                      (acc, item) => acc + item.balance,
                                      0
                                    ).toFixed(2)}
                                  </td>
                                  <td _ngcontent-ng-c3383274413="">
                                    <span
                                      _ngcontent-ng-c3383274413=""
                                      className={
                                        collectionReportMapping?.lenaHai?.reduce(
                                          (acc, item) => acc + item?.currentBalance,
                                          0
                                        ) < 0
                                          ? "mainus_value"
                                          : "plus_value"
                                      }
                                    >
                                      {" "}
                                      {parseFloat(
                                        collectionReportMapping?.lenaHai?.reduce(
                                          (acc, item) => acc + item?.currentBalance,
                                          0
                                        )
                                      ).toFixed(2)}{" "}
                                    </span>
                                  </td>
                                  <td _ngcontent-ng-c3383274413="">
                                    <span
                                      _ngcontent-ng-c3383274413=""
                                      className={
                                        collectionReportMapping?.lenaHai?.reduce(
                                          (acc, item) => acc + item?.balance,
                                          0
                                        ) < 0
                                          ? "mainus_value"
                                          : "plus_value"
                                      }
                                    >
                                      <strong _ngcontent-ng-c3383274413="">
                                        {parseFloat(
                                          collectionReportMapping?.lenaHai?.reduce(
                                            (acc, item) => acc + item?.balance,
                                            0
                                          )
                                        ).toFixed(2)}
                                      </strong>
                                    </span>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                          <div className="col-md-6">
                            <table
                              id="example12"
                              className="table table-striped  table-hover table-bordered"
                            >
                              <thead>
                                <tr>
                                  <th colSpan={5}>PAYMENT PAID TO (DENA HE)</th>
                                </tr>
                                <tr>
                                  <th>User Name</th>
                                  <th>Balance</th>
                                  <th></th>
                                  <th></th>
                                  {/* <th></th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {collectionReportMapping.denaHai.map((item) => (
                                  <tr>
                                    <td>{item.userName}</td>
                                    <td className={`${item?.openingBalance > 0 ? 'plus_value' : 'mainus_value'}`}>{item?.openingBalance?.toFixed(2)}</td>
                                    <td className={`${item?.currentBalance > 0 ? 'plus_value' : 'mainus_value'}`}>{item?.currentBalance?.toFixed(2)}</td>
                                    <td className="mainus_value">{item.balance.toFixed(2)}</td>
                                    {/* <td className="d-flex gap-2" style={{ gap: '5px' }}>
                                      <>
                                        <div className="btn-primary px-2 py-1" style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (item?.userType?.toUpperCase() !== "CLIENT") {
                                              navigate(
                                                `/ledger/${item?.userType}/children/${item?.userName?.split(" ")[0]}`
                                              );
                                            }
                                          }}
                                        >
                                          Downline
                                        </div>
                                        <div className="btn-primary px-3 py-1 d-flex gap-2 align-items-center" style={{ cursor: "pointer" }}
                                          onClick={() => navigateToCt(item)}>
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            strokeWidth={0}
                                            viewBox="0 0 24 24"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fill="none"
                                              strokeWidth={2}
                                              d="M2,7 L20,7 M16,2 L21,7 L16,12 M22,17 L4,17 M8,12 L3,17 L8,22"
                                            />
                                          </svg>
                                        </div>
                                      </>
                                    </td> */}
                                  </tr>
                                ))}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th>Total</th>
                                  <th className="mainus_value">
                                    {collectionReportMapping.denaHai.reduce(
                                      (acc, item) => acc + item.balance,
                                      0
                                    ).toFixed(2)}
                                  </th>
                                  <th _ngcontent-ng-c3383274413="">
                                    <span
                                      _ngcontent-ng-c3383274413=""
                                      className={
                                        collectionReportMapping?.denaHai?.reduce(
                                          (acc, item) => acc + item?.currentBalance,
                                          0
                                        ) < 0
                                          ? "mainus_value"
                                          : "plus_value"
                                      }
                                    >
                                      {" "}
                                      {parseFloat(
                                        collectionReportMapping?.denaHai?.reduce(
                                          (acc, item) => acc + item?.currentBalance,
                                          0
                                        )
                                      ).toFixed(2)}{" "}
                                    </span>
                                  </th>
                                  <th _ngcontent-ng-c3383274413="">
                                    <span
                                      _ngcontent-ng-c3383274413=""
                                      className={
                                        collectionReportMapping?.denaHai?.reduce(
                                          (acc, item) => acc + item?.balance,
                                          0
                                        ) < 0
                                          ? "mainus_value"
                                          : "plus_value"
                                      }
                                    >
                                      <strong _ngcontent-ng-c3383274413="">
                                        {parseFloat(
                                          collectionReportMapping?.denaHai?.reduce(
                                            (acc, item) => acc + item?.balance,
                                            0
                                          )
                                        ).toFixed(2)}
                                      </strong>
                                    </span>
                                  </th>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                      {/* /.card-body */}
                    </form>
                  </div>
                  {/* /.card */}
                </div>
                {/* /.col */}
              </div>
              {/* /.row */}
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <form action="#" method="post" id="demoForm">
                      <div className="card-header">
                        <h2 className="card-title">My Ledger</h2>
                      </div>
                      <div className="card-body">
                        <table
                          id="example1"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>SNo.</th>
                              <th>Date</th>
                              <th>Debit</th>
                              <th>Credit</th>
                              <th>Balance</th>
                              <th>Payment Type</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr _ngcontent-ng-c1578323060="" className="bd-blue-100">
                              <td _ngcontent-ng-c1578323060="" className="text-indigo text-lg text-center" colSpan={2}>
                                <b _ngcontent-ng-c1578323060="">Total Amount</b>
                              </td>
                              <td
                                _ngcontent-ng-c1578323060=""
                                className={
                                  parseFloat(
                                    ledgerQuery?.data?.response?.reduce(
                                      (acc, item) => acc + item?.debitInfo,
                                      0
                                    )
                                  ) < 0
                                    ? "mainus_value text-lg"
                                    : "plus_value text-lg"
                                }
                              >
                                <strong _ngcontent-ng-c1578323060="">
                                  {parseFloat(
                                    ledgerQuery?.data?.response?.reduce(
                                      (acc, item) => acc + item?.debitInfo,
                                      0
                                    )
                                  ).toFixed(2)}
                                </strong>
                              </td>
                              <td
                                _ngcontent-ng-c1578323060=""
                                className={
                                  parseFloat(
                                    ledgerQuery?.data?.response?.reduce(
                                      (acc, item) => acc + item?.creditInfo,
                                      0
                                    )
                                  ) < 0
                                    ? "mainus_value text-lg"
                                    : "plus_value text-lg"
                                }
                              >
                                <strong _ngcontent-ng-c1578323060="">
                                  {parseFloat(
                                    ledgerQuery?.data?.response?.reduce(
                                      (acc, item) => acc + item?.creditInfo,
                                      0
                                    )
                                  ).toFixed(2)}
                                </strong>
                              </td>
                              <td
                                _ngcontent-ng-c1578323060=""
                                className={
                                  parseFloat(
                                    ledgerQuery?.data?.response[0]?.updatedBalance
                                  ) < 0
                                    ? "text-red text-lg"
                                    : "text-blue text-lg"
                                }
                              >
                                <strong _ngcontent-ng-c1578323060="">
                                  {parseFloat(
                                    ledgerQuery?.data?.response[0]?.updatedBalance
                                  ).toFixed(2)}
                                </strong>
                              </td>
                              <td _ngcontent-ng-c1578323060="">&nbsp;</td>
                              <td _ngcontent-ng-c1578323060="" />
                            </tr>
                            {ledgerQuery?.data?.response
                              ?.sort(
                                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                              )
                              ?.map((item, index) => (
                                <tr _ngcontent-ng-c1578323060="">
                                  <td _ngcontent-ng-c1578323060="">
                                    {item?.accountLogId}
                                  </td>
                                  <td _ngcontent-ng-c1578323060="">
                                    <div
                                      _ngcontent-ng-c1578323060=""
                                      className="Date_time_box"
                                    >
                                      {moment(item?.createdAt + "Z").format(
                                        "DD-MM-YYYY HH:mm:ss"
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    _ngcontent-ng-c1578323060=""
                                    className={
                                      parseFloat(item?.debitInfo) < 0
                                        ? "mainus_value"
                                        : "plus_value"
                                    }
                                  >
                                    {item?.debitInfo &&
                                      parseFloat(item?.debitInfo).toFixed(2)}{" "}
                                  </td>
                                  <td
                                    _ngcontent-ng-c1578323060=""
                                    className={
                                      parseFloat(item?.creditInfo) < 0
                                        ? "mainus_value"
                                        : "plus_value"
                                    }
                                  >
                                    {" "}
                                    {item?.creditInfo &&
                                      parseFloat(item?.creditInfo).toFixed(2)}
                                  </td>
                                  <td
                                    _ngcontent-ng-c1578323060=""
                                    className={
                                      parseFloat(item?.updatedBalance) < 0
                                        ? "mainus_value"
                                        : "plus_value"
                                    }
                                  >
                                    {item?.updatedBalance &&
                                      parseFloat(item?.updatedBalance).toFixed(2)}
                                  </td>
                                  <td _ngcontent-ng-c1578323060="">{item?.sport}</td>
                                  <td _ngcontent-ng-c1578323060="">{item?.comment}</td>
                                </tr>
                              ))}
                          </tbody>
                          <tfoot />
                        </table>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
      }
    </div>
  );
}
